// Module
var code = "<h1 id=\"meetings\">Meetings</h1> <p>This tab contains a list of all the meetings scheduled be any staff member.</p> <p>The filters can be used to search for meetings created by a single staff member or meetings created on a specific date.</p> ";
// Exports
module.exports = code;